import {APIStatus} from '@web/core/constants'

import {PurchaseConfirmationState} from './interfaces'

export const getInitialState = (): PurchaseConfirmationState => ({
    /** 주문번호 */
    orderNo: '',
    /** C3 여부 */
    isC3Item: false,
    /** 예약상품 포함 여부 */
    containedPreOrderProduct: false,
    /** 보증금 잔여 여부  */
    remainedDeposit: false,
    /** 배송 진행중인 배송번호  */
    progressingDeliveryNo: '',
    /** 구매확정대상정보 */
    targetInfo: [],
    isInfiniteExtended: false,
    selectedInfo: {},
    apiStatus: APIStatus.IDLE,
    representationClaimStatusType: null,
})
